/* eslint-disable import/no-default-export */
import { Action, actionCreator } from 'app/gamma/src/util/actions';
import { createReducer } from 'app/gamma/src/util/reducers';

const SET_HEADER_BRANDING_COLOR = Symbol('ui/SET_HEADER_BRANDING_COLOR');
const REMOVE_HEADER_BRANDING_COLOR = Symbol('ui/REMOVE_HEADER_BRANDING_COLOR');
const SET_HEADER_BRANDING_LOGO = Symbol('ui/SET_HEADER_BRANDING_LOGO');
const REMOVE_HEADER_BRANDING_LOGO = Symbol('ui/REMOVE_HEADER_BRANDING_LOGO');

type SetHeaderBrandingColorAction = Action<
  typeof SET_HEADER_BRANDING_COLOR,
  string
>;
type RemoveHeaderBrandingColorAction = Action<
  typeof REMOVE_HEADER_BRANDING_COLOR,
  null
>;
type SetHeaderBrandingLogoAction = Action<
  typeof SET_HEADER_BRANDING_LOGO,
  string
>;
type RemoveHeaderBrandingLogoAction = Action<
  typeof REMOVE_HEADER_BRANDING_LOGO,
  null
>;

export interface HeaderState {
  brandingColor: string | undefined;
  brandingLogo: string | undefined;
}

const initialState: HeaderState = {
  brandingColor: undefined,
  brandingLogo: undefined,
};

export default createReducer(initialState, {
  [SET_HEADER_BRANDING_COLOR](
    state: HeaderState,
    { payload: brandingColor }: SetHeaderBrandingColorAction,
  ) {
    return {
      ...state,
      brandingColor,
    };
  },
  [REMOVE_HEADER_BRANDING_COLOR](state: HeaderState) {
    return {
      ...state,
      brandingColor: undefined,
    };
  },
  [SET_HEADER_BRANDING_LOGO](
    state: HeaderState,
    { payload: brandingLogo }: SetHeaderBrandingLogoAction,
  ) {
    return {
      ...state,
      brandingLogo,
    };
  },
  [REMOVE_HEADER_BRANDING_LOGO](state: HeaderState) {
    return {
      ...state,
      brandingLogo: undefined,
    };
  },
});

export const setHeaderBrandingColor = actionCreator<
  SetHeaderBrandingColorAction
>(SET_HEADER_BRANDING_COLOR);
export const removeHeaderBrandingColor = actionCreator<
  RemoveHeaderBrandingColorAction
>(REMOVE_HEADER_BRANDING_COLOR);
export const setHeaderBrandingLogo = actionCreator<SetHeaderBrandingLogoAction>(
  SET_HEADER_BRANDING_LOGO,
);
export const removeHeaderBrandingLogo = actionCreator<
  RemoveHeaderBrandingLogoAction
>(REMOVE_HEADER_BRANDING_LOGO);
